import React from 'react';
import logo from '../../assets/logo.png';
import sizeGuideImg from '../../assets/sizeGuide.jpeg';
import { Link } from 'react-router-dom';

const Footer = () => {

  const customerService = [
    // 'Contact Us', 'Shipping Info', 'Returns', 'FAQ', 'Track Order'
  ];


  return (
    <footer className="bg-navy-light text-gray-600 py-12">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div>
            <div className="flex items-center mb-4">
              <div className="w-8 h-8 bg-primary rounded-full flex items-center justify-center mr-2">
                <span className="text-white font-bold text-sm"><img src={logo} alt="EliteMed Apparel" className="h-8 w-8 mr-2" /></span>
              </div>
              <span className="text-xl font-bold text-gray-900">EliteMed</span>
            </div>
            <p className="text-sm mb-4">
              Premium medical scrubs designed for healthcare heroes. Comfort, style, and durability in every piece.
            </p>
          </div>


          <div>
            <h3 className="text-gray-900 font-semibold mb-4"></h3>
            <ul className="space-y-2">
              {customerService.map((link, index) => (
                <li key={index}>
                  <a href="#" className="text-sm hover:text-primary transition duration-300">{link}</a>
                </li>
              ))}
            </ul>
          </div>
          {/* Quick Links */}
          <div>
            <h3 className="text-gray-900 font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li key='0'>
                <Link to="/about" className="text-sm hover:text-primary transition duration-300">About Us</Link>
              </li>
              <li key='1'>
                <a href={sizeGuideImg} target="_blank" rel="noreferrer" className="text-sm hover:text-primary transition duration-300">Size Guide</a>
              </li>
            </ul>
          </div>

          {/* Customer Service
          <div>
            <h3 className="text-gray-900 font-semibold mb-4">Customer Service</h3>
            <ul className="space-y-2">
              {customerService.map((link, index) => (
                <li key={index}>
                  <a href="#" className="text-sm hover:text-primary transition duration-300">{link}</a>
                </li>
              ))}
            </ul>
          </div> */}

          {/* Contact Info */}
          <div>
            <h3 className="text-gray-900 font-semibold mb-4">Get in Touch</h3>
            <div className="space-y-3">
              <div className="flex items-center">
                <svg className="w-4 h-4 mr-2 text-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"></path>
                </svg>
                <span className="text-sm">(214) 931-5818</span>
              </div>
              <div className="flex items-center">
                <svg className="w-4 h-4 mr-2 text-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 8l7.89 4.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"></path>
                </svg>
                <span className="text-sm">contact@elitemedapparel.com</span>
              </div>
              {/* <div className="flex items-start">
                <svg className="w-4 h-4 mr-2 mt-0.5 text-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"></path>
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"></path>
                </svg>
                <span className="text-sm">S Bullock Dr<br/>Garland, TX, 75042</span>
              </div> */}
            </div>
          </div>
        </div>

        <div className="border-t border-primary/20 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-sm text-gray-500">
            © 2026 EliteMed. All rights reserved.
          </p>
          <div className="flex space-x-6 mt-4 md:mt-0">
            <a href="#" className="text-sm text-gray-500 hover:text-primary transition duration-300">Privacy Policy</a>
            <a href="#" className="text-sm text-gray-500 hover:text-primary transition duration-300">Terms of Service</a>
            <a href="#" className="text-sm text-gray-500 hover:text-primary transition duration-300">Accessibility</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;